import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { Grow, Typography } from '@mui/material';

import { Flex } from 'components/ui/flex';

import ProductPreviewV3 from './ProductPreviewV3';

const CheckoutThemePreviewV3 = ({
  logo,
  textColor,
  bgImage,
  bgMobileImage,
  fontFamily,
  onClose
}: {
  logo: string;
  textColor: string;
  bgImage: string;
  bgMobileImage?: string;
  onClose: () => void;
  fontFamily: string;
}) => {
  return (
    <Flex
      justify="center"
      align="center"
      onClick={() => onClose()}
      className="absolute top-0 left-0 z-[9999] w-full h-screen bg-black/75"
    >
      <Grow in>
        <Flex direction="row" justify="center" align="start" className="gap-16">
          <Flex align="center" className="gap-4">
            <Typography variant="h6" color={'white'} fontWeight={400}>
              Desktop
            </Typography>
            <Flex
              direction="row"
              className="w-[740px] h-[800px] bg-white rounded-[15px]"
            >
              <Flex
                className="w-[390px] gap-4 px-8 py-4 rounded-l-[15px]"
                style={{
                  backgroundImage: `url(${bgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center top'
                }}
              >
                <Flex direction="row" align="center" className="mt-4 gap-2">
                  <img
                    src={logo}
                    alt="logo"
                    style={{
                      height: '42px',
                      objectFit: 'contain',
                      width: '42px'
                    }}
                  />
                  <Typography
                    className="text-md"
                    color={textColor}
                    fontFamily={fontFamily}
                  >
                    Special Offer
                  </Typography>
                </Flex>
                <Flex>
                  <Flex
                    className="rounded-[7px]"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
                  >
                    <ProductPreviewV3
                      textColor={textColor}
                      name="Coins"
                      quantity="100,000"
                      imageUrl="./assets/images/checkout_item_1_v3.png"
                    />
                    <ProductPreviewV3
                      textColor={textColor}
                      name="Booster"
                      quantity="10,000"
                      imageUrl="./assets/images/checkout_item_2_v3.png"
                    />
                    <ProductPreviewV3
                      textColor={textColor}
                      name="XP"
                      quantity="1,000"
                      imageUrl="./assets/images/checkout_item_3_v3.png"
                    />
                  </Flex>
                  <div className="flex flex-col gap-1">
                    <div className="relative flex items-center border-1 rounded-md transition-all duration-200 focus-within:border-muted-foreground order-base-border pt-2">
                      <input
                        type="text"
                        placeholder="Promo Code"
                        value={''}
                        onChange={() => {}}
                        className="flex-1 p-2 h-10 pl-3 rounded-md outline-0 text-base md:text-sm font-family-sans appearance-none text-card-foreground bg-white cursor-default border-2 border-gray-300"
                      />
                      <div className="absolute right-4 flex items-center gap-2">
                        <FontAwesomeIcon
                          icon="fa-regular fa-tag"
                          className="text-card-foreground"
                        />
                      </div>
                    </div>
                  </div>
                  <Flex className="gap-2.5 mt-4">
                    <Flex direction="row" justify="between">
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        Subtotal
                      </Typography>
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        $ 19.90
                      </Typography>
                    </Flex>
                    <Flex direction="row" justify="between">
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        Tax (0%)
                      </Typography>
                      <Typography
                        fontSize={'14px'}
                        color={textColor}
                        fontFamily={fontFamily}
                      >
                        $ 0
                      </Typography>
                    </Flex>
                    <Flex direction="row" justify="between">
                      <Typography
                        color={textColor}
                        fontSize={'16px'}
                        fontWeight={500}
                        fontFamily={fontFamily}
                      >
                        Total
                      </Typography>
                      <Typography
                        color={textColor}
                        fontSize={'16px'}
                        fontWeight={500}
                        fontFamily={fontFamily}
                      >
                        $ 19.90
                      </Typography>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                align="center"
                className="w-full bg-white rounded-r-[15px] pt-4 relative"
              >
                <img
                  src={'./assets/images/checkout_theme_payments_v3.png'}
                  alt="checkout-theme-preview"
                />
              </Flex>
            </Flex>
          </Flex>
          <Flex align="center" className="gap-4">
            <Typography variant="h6" color={'white'} fontWeight={400}>
              Mobile
            </Typography>
            <Flex className="w-[340px] h-[800px] bg-white rounded-[15px] overflow-hidden">
              <Flex
                className="w-full gap-4 px-4 py-4 relative"
                style={{
                  backgroundImage: `url(${
                    bgMobileImage
                      ? bgMobileImage
                      : bgImage !== ''
                        ? bgImage
                        : 'none'
                  })`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center top'
                }}
              >
                <div
                  onClick={() => onClose()}
                  className="close-button"
                  style={{
                    cursor: 'pointer',
                    width: '25px',
                    height: '25px',
                    position: 'absolute',
                    right: '7px'
                  }}
                >
                  <FontAwesomeIcon
                    icon="fa-regular fa-xmark"
                    style={{ color: textColor }}
                  />
                </div>
                <Flex
                  direction="row"
                  justify="between"
                  align="center"
                  className="h-12 mt-4"
                >
                  <Flex direction="row" align="center" className="gap-2">
                    <img
                      src={logo}
                      alt="logo"
                      style={{
                        height: '48px',
                        objectFit: 'contain',
                        width: '48px'
                      }}
                    />
                    <Typography
                      fontSize={'14px'}
                      fontWeight={600}
                      textAlign="center"
                      style={{ color: textColor }}
                      fontFamily={fontFamily}
                    >
                      Special Offer
                    </Typography>
                  </Flex>
                  <Flex direction="row" align="center" className="gap-1">
                    <FontAwesomeIcon
                      icon="fa-regular fa-tag"
                      style={{ color: textColor }}
                    />
                    <Typography
                      className="font-medium text-center"
                      fontSize={'12px'}
                      color={textColor}
                      fontFamily={fontFamily}
                    >
                      Details
                    </Typography>
                    <FontAwesomeIcon
                      icon="fa-regular fa-chevron-down"
                      style={{ color: textColor }}
                    />
                  </Flex>
                </Flex>
                <Flex direction="row" justify="between" className="gap-4">
                  <Typography
                    variant="h6"
                    color={textColor}
                    fontFamily={fontFamily}
                    fontSize={'1em'}
                    fontWeight={500}
                    boxSizing={'border-box'}
                  >
                    Total
                  </Typography>
                  <Typography
                    variant="h6"
                    color={textColor}
                    fontFamily={fontFamily}
                    fontSize={'1em'}
                    fontWeight={500}
                    boxSizing={'border-box'}
                  >
                    $ 19.90
                  </Typography>
                </Flex>
              </Flex>
              <img
                src={'./assets/images/checkout_theme_payments_v3_mobile.png'}
                alt="checkout-theme-preview"
              />
            </Flex>
          </Flex>
        </Flex>
      </Grow>
    </Flex>
  );
};

export default CheckoutThemePreviewV3;
